import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { Vue3Lottie } from 'vue3-lottie'
import preloaderHeart from '@web/platform.v3/assets/lottie/preloader-heart.json'

interface Props {
  size?: number | string
  fullpage?: boolean
  overlay?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AcLottiePreloader',
  props: {
    size: { default: 100 },
    fullpage: { type: Boolean, default: false },
    overlay: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const normalizedSize = computed(() =>
  typeof props.size === 'number' ? `${props.size}px` : props.size
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["acLottiePreloader", {
      'acLottiePreloader--fullpage': __props.fullpage,
      'acLottiePreloader--overlay': __props.overlay
    }]),
    "data-test": "ac-lottie-preloader",
    role: "status",
    "aria-label": "Загрузка"
  }, [
    _createVNode(_unref(Vue3Lottie), {
      "animation-data": _unref(preloaderHeart),
      height: normalizedSize.value,
      width: normalizedSize.value,
      loop: true,
      "auto-play": true,
      "aria-hidden": "true"
    }, null, 8, ["animation-data", "height", "width"])
  ], 2))
}
}

})